import { IState } from 'core/types';

export const getIsLoggedIn = ({ auth: { isLoggedIn } }: IState) => isLoggedIn;

export const getAuthSelector = ({ auth }: IState) => auth;
